module.exports = __webpack_public_path__ + "static/media/Statistic.be207afe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/artist-ui/components/Image/Statistic.svg
// module id = 409
// module chunks = 0